import * as React from 'react'
import Chip from '@mui/material/Chip'
import K from '../../services/k'

const OrderComponent = ({ item, prep_meal }) => {
  const OpenTrackingPage = () => {
    localStorage.setItem(
      'currentOrderId',
      prep_meal ? item.id : item?.order_details?.id,
    )
    localStorage.setItem('currentOrderIsPrepMeal', prep_meal)
    window.location.href = '/track-order'
  }

  const OpenReceiptPage = () => {
    localStorage.setItem(
      'currentOrderId',
      prep_meal ? item.id : item?.order_details?.id,
    )
    localStorage.setItem('currentOrderIsPrepMeal', prep_meal)
    window.location.href = '/receipt-order'
  }

  //end tracking widget state.
  const getStatus = (str) => {
    let status = ''
    switch (str) {
      case 'submitted':
        status = 'Order Received'
        break
      case 'accepted':
        status = 'Order Accepted And Being Prepared'
        break
      case 'ready':
        status = 'Order Ready'
        break
      case 'dispatched':
        status = 'Order Dispatched'
        break
      case 'enroute_to_customer':
        status = 'Roadie On Way To Your Place'
        break
      case 'arrived_at_customer':
        status = 'Roadie At Your Place'
        break
      case 'delivered':
        status = 'Order Complete'
        break
      case 'rejected':
        status = 'Order Declined'
        break
      default:
        break
    }
    return status
  }

  const getMealName = (item) => {
    if (prep_meal) {
      return item?.orderinfo.cart_data[0]?.meal_name
    } else {
      return item?.order_items[0]?.meal_name
    }
  }

  const getQuantity = (item) => {
    if (prep_meal) {
      return item?.orderinfo.cart_data.length
    } else {
      return item?.order_items.length
    }
  }

  const getPrice = (item) => {
    let totalPrice = 0
    if (prep_meal) {
      item?.orderinfo.cart_data.map((it) => {
        totalPrice += it.price * it.quantity
      })
    } else {
      item.order_items.map((it) => {
        totalPrice += it.price
      })
    }
    return totalPrice
  }
  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div
          className="category-item"
          style={{ alignItems: 'initial', padding: 5 }}
        >
          <div
            className="left"
            style={{
              background: `ghostwhite url(` + K.imageBaseUlr + `cake.jpg` + `)`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              width: '40%',
              height: '200px',
            }}
          ></div>

          <div className="right rateee">
            <div className="rightContent">
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <td>
                      <span>{prep_meal ? 'Prep Meal ' : ''}Order ID: </span>
                    </td>
                    <td>
                      <b>#{prep_meal ? item.id : item.order_details?.id}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Restaurant: </span>
                    </td>
                    <td>
                      <b>{item.order_details?.restaurantdata?.rname}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Meals: </span>
                    </td>
                    <td>
                      <b>
                        {getQuantity(item)} x {getMealName(item)}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Price: </span>
                    </td>
                    <td>
                      <b>$ {getPrice(item)}.00</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Description: </span>
                    </td>
                    <td>
                      <span>
                        {prep_meal
                          ? item.delivery_description
                          : item.order_details?.delivery_description}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Status: </span>
                    </td>
                    <td>
                      <Chip
                        label={getStatus(
                          prep_meal ? item.status : item.order_details?.status,
                        )}
                        className={`text ${
                          item.order_details?.status === 'delivered' ||
                          item.status === 'delivered'
                            ? 'text-success'
                            : item.order_details?.status === 'ready'
                            ? 'text-primary'
                            : item.order_details?.status === 'accepted'
                            ? 'text-info'
                            : item.order_details?.status === 'accepted'
                            ? 'text-secodary'
                            : item.order_details?.status === 'dispatched'
                            ? 'text-warning'
                            : 'text-danger'
                        }`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {item.order_details?.status === 'delivered' ||
                      item.order_details?.status === 'rejected' ? (
                        ''
                      ) : (
                        <button
                          className={'primary-btn mr-3'}
                          style={{ height: 25, padding: '3px 20px' }}
                          onClick={() => {
                            OpenTrackingPage()
                          }}
                        >
                          Track Order
                        </button>
                      )}
                      <button
                        className={'primary-btn'}
                        style={{ height: 25, padding: '3px 20px' }}
                        onClick={() => {
                          OpenReceiptPage()
                        }}
                      >
                        {' '}
                        Receipt{' '}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderComponent
